import { SvgIconDefinition } from '@am/icons-common-types';
const width = 128;
const height = 128;
const path = `M78.443,0H7.894C3.54,0,0,3.938,0,8.776V118.36h6.36V8.776c0-1.382,0.807-2.416,1.534-2.416h70.549c0.708,0,1.534,1.056,1.534,2.416V118.36h6.36V8.776C86.337,3.938,82.797,0,78.443,0z M72.681,10.513L22.55,14.871c-2.171,0-3.947,2.368-3.947,5.262v83.849l58.024,14.378V15.775C76.628,12.881,74.852,10.513,72.681,10.513z M28.116,66.273c-2.054,0-3.719-1.665-3.719-3.72s1.665-3.72,3.719-3.72c2.054,0,3.72,1.665,3.72,3.72S30.17,66.273,28.116,66.273z`;

export const aciConnectingRoom: SvgIconDefinition = {
  iconName: 'connecting-room',
  iconData: [height, width, path],
};
